<script setup lang="ts">
import { getOptions } from '@/api/api';
import { useBookingDataStore } from '@/stores/bookingData';
import { onMounted, ref } from 'vue';


const options = ref(Array());

const bookingData = useBookingDataStore();

onMounted(async () => {
  const s = await getOptions();
  if (s?.success && s.data) {
    options.value = s.data;
  }
});

function getOptionName(id: string) {
  return options.value.find(f => f.Id == id)?.Titre || '';
}

function orderedOptions() {
  return bookingData.options.filter(v => v.quantity > 0);
}

</script>
<template>
  <div>
    <div class="bpa-front-module-heading" v-if="orderedOptions().length > 0">Options</div>
    <div class="menu-summary" v-for="item in orderedOptions()" :key="item.id">{{ item.quantity }} x {{
      getOptionName(item.id) }}</div>
    <br />

  </div>
</template>

<style scoped>
@media only screen and (max-width: 576px) {
  .menu-summary {
    margin: 0px 15px;
  }
}
</style>
